import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import rootAxios from "requests/rootAxios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Thunk to fetch calendar data
export const getCalendarData = createAsyncThunk(
  "calendar/getCalendarData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await rootAxios.get(`${BASE_URL}/user/get-calendar`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const postCalendarData = createAsyncThunk(
    "calendar/postCalendarData",
    async (payload, { rejectWithValue }) => {
      try {
        console.log("payload",payload)
        const response = await rootAxios.post(`${BASE_URL}/super-user/create-training-schedule`,{"data":payload.data,"action":payload.action});
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
      }
    }
  );

// Slice
const calendarSlice = createSlice({
    name: "calendar",
    initialState: {
      data: [],
      loading: false,
      error: null,
      postStatus: null, // To track the status of the postCalendarData action
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        // Reducers for getCalendarData
        .addCase(getCalendarData.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getCalendarData.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
        })
        .addCase(getCalendarData.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Reducers for postCalendarData
        .addCase(postCalendarData.pending, (state) => {
          state.postStatus = "loading";
          state.error = null;
        })
        .addCase(postCalendarData.fulfilled, (state, action) => {
          state.postStatus = "success";
          //state.data.push(action.payload); // Optionally update state data with the new item
        })
        .addCase(postCalendarData.rejected, (state, action) => {
          state.postStatus = "failed";
          state.error = action.payload;
        });
    },
  });
  
  export default calendarSlice.reducer;
  